import ParentLoginFrom from "../../components/parentLogin/ParentLoginForm";
import UserLoginForm from "../../components/userLogin/UserLoginForm";
import { Switch, Route, useRouteMatch, Link } from "react-router-dom";
import "./Login.css";
const Login = () => {
  let { path, url } = useRouteMatch();

  console.log(path);
  console.log(url);
  return (
    <div id="login">
      <h1>ברוכים הבאים</h1>
      <Switch>
        <Route exact path={path}>
          <UserLoginForm />
        </Route>
        <Route path={`${path}/parents`}>
          <ParentLoginFrom />
        </Route>
      </Switch>
    </div>
  );
};

export default Login;
